<svg width="153" height="151" viewBox="0 0 153 151" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="question_answer_black_24dp (1) 2" clip-path="url(#clip0_3820_7479)">
<path id="Vector" d="M133.875 37.7526H121.125V94.3776H38.25V106.961C38.25 110.421 41.1188 113.253 44.625 113.253H114.75L140.25 138.419V44.0443C140.25 40.5839 137.381 37.7526 133.875 37.7526ZM108.375 75.5026V18.8776C108.375 15.4172 105.506 12.5859 102 12.5859H19.125C15.6188 12.5859 12.75 15.4172 12.75 18.8776V106.961L38.25 81.7943H102C105.506 81.7943 108.375 78.963 108.375 75.5026Z" fill="#DFDFDF"/>
</g>
<defs>
<clipPath id="clip0_3820_7479">
<rect width="153" height="151" fill="white"/>
</clipPath>
</defs>
</svg>
